import * as tslib_1 from "tslib";
import { BaseService } from '../../_helpers';
import { DictionaryEntity } from '../entity';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DeviceDictionaryService = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceDictionaryService, _super);
    function DeviceDictionaryService(http) {
        var _this = _super.call(this, 'config/devices/idAndNames', DictionaryEntity) || this;
        _this.http = http;
        return _this;
    }
    DeviceDictionaryService.ngInjectableDef = i0.defineInjectable({ factory: function DeviceDictionaryService_Factory() { return new DeviceDictionaryService(i0.inject(i1.HttpClient)); }, token: DeviceDictionaryService, providedIn: "root" });
    return DeviceDictionaryService;
}(BaseService));
export { DeviceDictionaryService };
